// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"6ec11c66","174":"db5e13d3","465":"9313dfa6"}[chunkId] + ".chunk.css";
};